import {
  apiErrorData,
  isApiError,
  isUsageLimitExceededData,
} from "@/core/lib/api-errors";
import { addToast } from "@/core/lib/toast";
import { m } from "@/paraglide/messages";

const handledUsageLimitErrors = new WeakSet<object>();

export function handleUsageLimitExceededError(error: unknown): boolean {
  if (!isUsageLimitExceededError(error)) {
    return false;
  }
  if (typeof error === "object" && error !== null) {
    if (handledUsageLimitErrors.has(error)) return true;
    handledUsageLimitErrors.add(error);
  }

  addToast({
    title: m.toast_ai_usage_limit_exceeded(),
    severity: "danger",
    error,
  });
  return true;
}

function isUsageLimitExceededError(error: unknown): boolean {
  return isApiError(error) && isUsageLimitExceededData(apiErrorData(error));
}
